import React from "react";
import { useIntl } from "react-intl";
import { Form, Icon, Button, Input } from "antd";

import PasswordFormItem from "../passwordFormItem";
import LoginFormContainer from "../loginFormContainer";

const { Item } = Form;

const LoginForm = ({ form, onSubmit, loading }) => {
  const intl = useIntl();
  return (
    <LoginFormContainer>
      <Form onSubmit={onSubmit}>
        <Item>
          {form.getFieldDecorator("username", {
            rules: [
              {
                required: true,
                message: intl.formatMessage({
                  id: "user.signIn.emptyUserName",
                  defaultMessage: "Vyplňte prosím uživatelské jméno!",
                }),
              },
            ],
          })(
            <Input
              prefix={<Icon type="user" className="form-input-icon" />}
              placeholder={intl.formatMessage({
                id: "user.signIn.username",
                defaultMessage: "uživatelské jméno",
              })}
              autoComplete="username"
            />
          )}
        </Item>
        <PasswordFormItem
          fieldName="password"
          placeHolder={intl.formatMessage({
            id: "user.signIn.password",
            defaultMessage: "heslo",
          })}
          autoComplete="current-password"
          message={intl.formatMessage({
            id: "user.signIn.emptyPassword",
            defaultMessage: "Vyplňte prosím heslo!",
          })}
          getFieldDecorator={form.getFieldDecorator}
        />
        <Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            {intl.formatMessage({
              id: "user.signIn.signIn",
              defaultMessage: "Přihlásit se",
            })}
          </Button>
        </Item>
      </Form>
    </LoginFormContainer>
  );
};

export default Form.create()(LoginForm);
